import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { ReInviteMembers, reinviteMembersAction } from '../actions';
import { MembersAPI } from '../api';
import { addMembers } from '../slice';

function* inviteMembers(payload, handleSuccess) {
  const users = yield MembersAPI.inviteMembers(payload);

  yield put(addMembers(users));

  if (handleSuccess) {
    handleSuccess();
  }
}
function* resendMemberInvitationSaga(action: PayloadAction<ReInviteMembers>) {
  const {
    payload: {
      data,
      handleAlways = () => {},
      handleSuccess,
      handleFailure = () => {},
    },
  } = action;

  try {
    const payload = data;

    yield inviteMembers(payload, handleSuccess);
  } catch (error) {
    handleFailure();
  }

  handleAlways();
}

export const watchResendMemberInvitationSaga = function* (): Generator {
  yield takeLatest(reinviteMembersAction.type, resendMemberInvitationSaga);
};
